///<reference path="../../our-iron.ts"/>

module ProcessEditor {

    export var app = angular.module("processEditor", ["ngResource", "ngRoute", "ngMessages", "frends-utils", "ui.bootstrap", "ngTagsInput", "ui.codemirror", "ui.select", "ngSanitize"]);

    app.service("jsPlumb", (): jsPlumbInstance => jsPlumb);

    app.config([
        "$routeProvider", "$locationProvider",
        ($routeProvider: ng.route.IRouteProvider, $locationProvider: ng.ILocationProvider) => {

            $locationProvider.html5Mode(true);

            $routeProvider
                .when('/Process/EditV42/:id', {
                    templateUrl: 'processEditor.htm',
                    controller: 'ProcessEditorController',
                    controllerAs: 'ctrl'
                }).when('/Process/NewV42', {
                    templateUrl: 'processEditor.htm',
                    controller: 'ProcessEditorController',
                    controllerAs: 'ctrl'
                }).when('/ProcessInstance', {
                    templateUrl: 'processEditor.htm',
                    controller: 'ProcessDetailsController',
                    controllerAs: 'ctrl'
                }).otherwise({
                    redirectTo: '/Process'
                });
        }
    ]);
}